<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div
  class="tab"
  [ngClass]="{
    'variant-primary': variant === 'primary',
    'variant-secondary': variant === 'secondary',
    'variant-tertiary': variant === 'tertiary',
    'style-underline': mode === 'underline',
    'style-text': mode === 'text',
    disabled: disabled,
    selected: selected,
    active: !disabled && !selected
  }"
  [attr.aria-selected]="selected"
  (click)="onTabClick()"
>
  <div class="tab-content">
    <ng-container *ngIf="icon">
      <hyperkit-icon color="inherit" size="small" [icon]="icon"></hyperkit-icon>
    </ng-container>
    <hyperkit-typography
      [variant]="typographyVariant"
      color="inherit"
      class="text"
    >
      {{ text }}
    </hyperkit-typography>
    <ng-container *ngIf="variant !== 'tertiary' && count !== null">
      <hyperkit-typography
        variant="label2"
        color="inherit"
        class="count"
      >
        {{ count }}
      </hyperkit-typography>
    </ng-container>
  </div>

  <!-- Underline -->
  <div *ngIf="variant !== 'tertiary'" class="underline-wrapper">
    <div class="underline" *ngIf="mode === 'underline' && selected"></div>
  </div>
</div>

<!-- Capturing the content for uncontrolled tabs -->
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
